import React from "react"
import "../styles/sending.scss"

const Sending = () => {
  return <div className="lds-dual-ring"></div>
}

export default Sending
